//react
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
//UI
import { Drawer, Tabs } from "antd";
import { CardElement } from "../../../components/Common/UIElements";
import CorporateUserForm from "../../../components/Onboarding/CorporateUserForm/CorporateUserForm";
import PropertyUserForm from "../../../components/Onboarding/PropertyUserForm/PropertyUserForm";
import CorporateContactUsers from "../../../components/Onboarding/OnboardingUsers/CorporateContactUsers/CorporateContactUsers";
import PropertyContactUsers from "../../../components/Onboarding/OnboardingUsers/PropertyContactUsers/PropertyContactUsers";

//processing
import useQuery from "../../../hooks/url.hooks";
import { simpleStringDecode } from "../../../utils/common-utils";
import { RECORD_OPERATIONS } from "../../../utils/onboarding-helper";

const OnboardingUsers = () => {
  const query = useQuery();
  const customerId = simpleStringDecode(query.get("customer"));

  const queryTab = query.get("tab");

  const [customer, setCustomer] = useState(customerId || "");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [tabKey, setTabKey] = useState(queryTab || "corporate_user");
  const [operation, setOperation] = useState("");
  const [operationData, setOperationData] = useState("");

  const onTabClick = (key) => {
    setTabKey(key);
    setOperation("");
    setOperationData("");
  };

  const openDrawer = () => {
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const addCorporateUser = () => {
    setOperation(RECORD_OPERATIONS.ADD);
    setOperationData({});
    openDrawer();
  };

  const addPropertyUser = () => {
    setOperation(RECORD_OPERATIONS.ADD);
    setOperationData({});
    openDrawer();
  };

  const drawerData = {
    corporate_user: {
      title:
        operation === RECORD_OPERATIONS.ADD
          ? "Add Corporate Contact User"
          : "Edit Corporate Contact User",
      content: (
        <CorporateUserForm
          closeDrawer={closeDrawer}
          operation={operation}
          operationData={operationData}
          customer={customer}
        />
      ),
    },
    property_user: {
      title:
        operation === RECORD_OPERATIONS.ADD
          ? "Add Property Contact User"
          : "Edit Property Contact User",
      content: (
        <PropertyUserForm
          closeDrawer={closeDrawer}
          operation={operation}
          operationData={operationData}
          customer={customer}
        />
      ),
    },
  };

  const items = [
    {
      key: "corporate_user",
      label: "Corporate Contact User",
      children: (
        <CorporateContactUsers
          openDrawer={openDrawer}
          addCorporateUser={addCorporateUser}
          customer={customer}
          setCustomer={setCustomer}
          setOperation={setOperation}
          setOperationData={setOperationData}
          drawerOpen={drawerOpen}
        />
      ),
    },
    {
      key: "property_user",
      label: "Property Contact User",
      children: (
        <PropertyContactUsers
          openDrawer={openDrawer}
          addPropertyUser={addPropertyUser}
          customer={customer}
          setCustomer={setCustomer}
          setOperation={setOperation}
          setOperationData={setOperationData}
        />
      ),
    },
  ];

  return (
    <CardElement title="System Discovery">
      <Tabs activeKey={tabKey} items={items} onTabClick={onTabClick} />
      <Drawer
        title={drawerData[tabKey].title}
        placement="right"
        open={drawerOpen}
        onClose={closeDrawer}
      >
        {drawerData[tabKey].content}
      </Drawer>
    </CardElement>
  );
};

export default OnboardingUsers;
